export default {
  layouts: {
    acquring: {
      balances: 'Список оплат',
      scoring: 'Оценка карт',
      searchClients: 'Поиск клиента',
    },
  },
};
